export const config = {
	base_url: process.env.REACT_APP_BASE_URL || '',
	bscsan_url:
		process.env.REACT_APP_ENV === 'development'
			? 'https://testnet.bscscan.com/'
			: 'https://bscscan.com/',
};
